<div class="card-container">
    <div class="flip-card">
        <div class="flip-card-inner">
            <div class="flip-card-front">

            </div>
            <div class="flip-card-back center p-t-5 p-t-3-s p-b-5 p-b-3-s">
                <div class="pos-relative m-b-5 m-b-3-s">
                    <p [sizeClass]="'S: p1, !S: h3'">{{'Day %' | translate : data.tile.number}}</p>
                    <button class="pos-absolute right-5 right-3-s top-50 cursor-pointer inline-flex"
                            type="button"
                            (click)="close()"
                            aria-label="Close modal window">
                        <i [style.font-size.px]="client.isS ? 9 : 14"
                           aria-hidden="true"
                           class="icon-close inline-flex"></i>
                    </button>
                </div>
                <div class="_contentCard">
                    <div class="w-12 ratio-16-9">
                        <img class="fill"
                             [image]="data.tile.imageInPopup || data.tile.product?.data?.image"
                             [options]="{fitIn: true, fillColor: 'transparent'}">
                    </div>

                    <div class="p-l-5 p-r-5 p-l-3-s p-r-3-s">
                        <label class="_label m-t-5 m-t-3-s inline-block"
                               [ngClass]="[data.component.labelBackground || 'bg-col-6', data.component.labelTextColor || 'col-w']"
                               [sizeClass]="'S: p2, !S: p1'">
                            {{data.tile.status === ETileStatus.expired || data.tile.status === ETileStatus.expiredOpened
                            ? data.component.expiredLabel : data.component.limitedTimeOfferLabel}}
                        </label>

                        <div class="m-t-5 m-t-3-s line-clamp-3"
                             [sizeClass]="'S: p2, !S: p1'"
                             [innerHtml]="data.tile.popupTitle || data.tile.product?.data?.name">

                        </div>

                        <div class="m-t-1 line-clamp-3"
                             [sizeClass]="'S: p3, !S: p2'"
                             [innerHtml]="data.tile.popupDescription || data.tile.product?.data?.description">
                        </div>

                        @if(data.tile.product) {
                        <div class="w-12 m-t-1">
                            <price class="inline-block price va-m"
                                   [sizeClass]="'S: p2, !S: o1'"
                                   [class.col-6]="data.tile.product.orgPrice"
                                   [value]="data.tile.product.price"></price>
                            <!-- org price for discount -->
                            @if (data.tile.product.orgPrice) {
                            <price class="m-l-3 col-11 inline-block va-m price line-through"
                                   [sizeClass]="'S: p3, !S: p2'"
                                   [value]="data.tile.product.orgPrice"></price>
                            }
                        </div>

                        }
                    </div>

                </div>
                @if(data.tile.status === ETileStatus.available || data.tile.status === ETileStatus.opened) {
                <href [link]="data.tile.product?.data?.url || data.tile.popupLink">
                    <span class="button m-t-5 m-t-3-s">{{ data.tile.popupButtonText || 'View Offer' | translate}}</span>
                </href>
                }
            </div>
        </div>
    </div>
</div>
